<template>
  <div :class="cssPeriod" @click="btnPeriod">
    <div class="circle" v-if="period.enable">{{ resvNumber }}</div>
    <div v-else>
      <img src="@/assets/images/star.png" style="width:1.8rem;" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentPeriod",
  props: ["period"],
  emits: ["changePeriod"],
  data() {
    return {};
  },
  computed: {
    cssPeriod() {
      const active = this.period.enable ? "active" : "";
      return `dotBox ${active} ${this.period.sec} ${this.period.dn}`;
    },
    resvNumber() {
      let no =
        this.period.就診參考序號 >= 99 ? "99+" : this.period.就診參考序號;
      return this.period.enable ? no : "x";
    },
    available() {
      return this.period.enable ? "circle" : "star";
    }
  },
  methods: {
    btnPeriod() {
      this.$emit("changePeriod", this.period);
    }
  }
};
</script>
